<nav class="navbar navbar-expand-lg navbar-dark bg-dark d-inline-flex w-100 justify-content-between">
  <a class="navbar-brand p-0" [routerLink]="['']">
    <img src="../../assets/images/bg-logo1.png" style="min-height: 45px;" alt="mylev" class="logoImg">
  </a>
  <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarNav" aria-controls="navbarNav"
    aria-expanded="false" aria-label="Toggle navigation">
    <span class="navbar-toggler-icon"></span>
  </button>
  <div class="collapse navbar-collapse justify-content-end" id="navbarNav">
    <ul class="navbar-nav">
      <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
        <a class="nav-link" [routerLink]="['']">Анализи<span class="sr-only">(current)</span></a>
      </li>
      <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
        <a class="nav-link" [routerLink]="['transaction']">Трансакции</a>
      </li>
      <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
        <a class="nav-link" [routerLink]="['goals']">Цели</a>
      </li>
      <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
        <a class="nav-link" [routerLink]="['openai']">Помощник</a>
      </li>
      <li class="nav-item" [routerLinkActive]="['active']" [routerLinkActiveOptions]="{exact:true}">
        <a class="nav-link" [routerLink]="['exchange']">Валутен конвертор</a>
      </li>
      <li class="nav-item">
        <a class="nav-link log-out" (click)="logout()">Излез</a>
      </li>
    </ul>
  </div>
</nav>